<template>
    <div class="other_data_wrap">
        <StockData :menuList="menuList" @changeActive="changeActive" @changeItemActive="changeItemActive" :activeIndex="0">
            <div class='other_data_content stock_detail' slot='stock_detail'>
                <div class='flex-center exchange_name'>
                    <div>{{ otherInfo.name }}</div>
                </div>
                <div class='data_card'>
                    <!-- 奥运奖牌 -->
                    <div v-if="otherInfo.name == '奥运奖牌'" class='filter_wrap'>
                        <!-- 过滤数据 -->
                        <div class='filter_button flex-center'>
                            <div @click='labelSwitching(item)' v-for='item in olympicInfo.filterArr' :key='item.id'
                                 :class="otherInfo.filterIndex == item.id ? 'active_button' : ''">{{ item.title }}
                            </div>
                        </div>
                        <div class='other_info_text'>数据描述：<span>{{ otherInfo.info }}</span></div>
                        <div class='data_card'>
                            <div class='top_tips'>选择比赛年份<span class='ml10'>* 年份可选范围为1896-2016年度</span>
                            </div>
                            <div class='flex-center'>
                                <el-date-picker
                                    v-model='selectRange[0]'
                                    align='right'
                                    type='year'
                                    :picker-options='pickerOptions'
                                    placeholder='开始年份'
                                    value-format='yyyy-MM-dd'>
                                </el-date-picker>
                                <div>
                                    &nbsp;&nbsp;--&nbsp;&nbsp;
                                </div>
                                <el-date-picker
                                    v-model='selectRange[1]'
                                    align='right'
                                    type='year'
                                    :picker-options='pickerOptions'
                                    placeholder='结束年份'
                                    value-format='yyyy-MM-dd'>
                                </el-date-picker>
                            </div>
                        </div>
                    </div>
                    <!-- 汽车销量排行 -->
                    <div v-if="otherInfo.name == '汽车销量'" class='filter_wrap'>
                        <!-- 过滤数据 -->
                        <div class='filter_button flex-center'>
                            <div @click='labelSwitching(item)' v-for='(item,index) in carSaleInfo.filterArr'
                                 :key='index' :class="otherInfo.filterIndex == item.id ? 'active_button' : ''">
                                {{ item.title }}
                            </div>
                        </div>
                        <div class='other_info_text'>数据描述：<span>{{ otherInfo.info }}</span></div>
                        <div class='data_card'>
                            <div class='top_tips'>选择数据月份<span class='ml10'>返回指定月的不同车企汽车销量数据</span>
                            </div>
                            <div>
                                <el-date-picker
                                    v-model='selectDay'
                                    align='right'
                                    type='month'
                                    placeholder='选择月份'
                                    value-format='yyyy-MM-dd'
                                    :picker-options='pickerOptions'>
                                </el-date-picker>
                            </div>
                        </div>
                    </div>
                    <!-- 新闻联播文字稿 -->
                    <div v-if="otherInfo.name == '新闻联播文字'">
                        <div class='other_info_text'>数据描述：<span>{{ otherInfo.info }}</span></div>
                        <div class='data_card'>
                            <div class='top_tips'>选择日期范围</div>
                            <div style='width:50%'>
                                <el-date-picker
                                    v-model='selectRange'
                                    type='daterange'
                                    value-format='yyyy-MM-dd'
                                    range-separator='至'
                                    start-placeholder='开始日期'
                                    end-placeholder='结束日期'>
                                </el-date-picker>
                            </div>
                        </div>
                    </div>
                    <!-- 日出和日落 -->
                    <div v-if="otherInfo.name == '日出和日落'" class='filter_wrap'>
                        <!-- 过滤数据 -->
                        <div class='filter_button flex-center'>
                            <div @click='labelSwitching(item)' v-for='(item,index) in sunInfo.filterArr' :key='index'
                                 :class="otherInfo.filterIndex == item.id ? 'active_button' : ''">{{ item.title }}
                            </div>
                        </div>
                        <div class='other_info_text'>数据描述：<span>{{ otherInfo.info }}</span></div>
                        <div class='data_card'>
                            <div class='top_tips'>选择日期范围<span class='ml10'>* 数据可选范围在1999-01-01—至今</span>
                            </div>
                            <div v-if='otherInfo.filterIndex == 14'>
                                <el-date-picker
                                    v-model='selectDay'
                                    align='right'
                                    type='date'
                                    placeholder='选择日期'
                                    value-format='yyyy-MM-dd'
                                    :picker-options='pickerOptions'>
                                </el-date-picker>
                            </div>
                            <div v-if='otherInfo.filterIndex == 15'>
                                <el-date-picker
                                    v-model='selectDay'
                                    align='right'
                                    type='month'
                                    placeholder='选择月份'
                                    value-format='yyyy-MM-dd'
                                    :picker-options='pickerOptions'>
                                </el-date-picker>
                            </div>
                        </div>
                    </div>
                    <!-- 空气质量 -->
                    <div v-if="otherInfo.name == '空气质量'" class='filter_wrap'>
                        <!-- 过滤数据 -->
                        <div class='filter_button flex-center'>
                            <div @click='labelSwitching(item)' v-for='item in airQualityInfo.filterArr' :key='item.id'
                                 :class="otherInfo.filterIndex == item.id ? 'active_button' : ''">{{ item.title }}
                            </div>
                        </div>
                        <div class='other_info_text'>数据描述：<span>{{ otherInfo.info }}</span></div>
                        <!-- 空气质量等级划分 -->
                        <div>
                            <el-table :data='airQualityInfo.tableData'
                                      :cell-style="{textAlign:'center',padding:'5px 0px'}" stripe
                                      :header-cell-style='$core.table_header'>
                                <el-table-column prop='index' label='空气污染指数'></el-table-column>
                                <el-table-column prop='grade' label='空气质量级别'></el-table-column>
                                <el-table-column prop='status' label='空气质量状况'></el-table-column>
                                <el-table-column prop='proposal' width='600' label='生活建议'></el-table-column>
                            </el-table>
                        </div>
                        <!-- 全国空气质量 -->
                        <div class='data_card' v-if='otherInfo.filterIndex == 16'>
                            <div class='top_tips'>选择省份/城市</div>
                            <div class='flex-center'>
                                <div>
                                    <el-select v-model='airQualityInfo.province' @change='getProvinceOrCity'>
                                        <el-option :label='item' :key='index'
                                                   v-for='(item,index) in airQualityInfo.provinceArr'
                                                   :value='item'></el-option>
                                    </el-select>
                                </div>
                                <div>&nbsp;&nbsp;---&nbsp;&nbsp;</div>
                                <div>
                                    <el-select v-model='airQualityInfo.city'>
                                        <el-option :label='item' :key='index'
                                                   v-for='(item,index) in airQualityInfo.cityArr'
                                                   :value='item'></el-option>
                                    </el-select>
                                </div>
                            </div>
                            <div class='top_tips mat20'>选择日期范围<span class='ml10'>* 若提取小时频率数据请注意时间跨度不宜过长，提取日频率数据的早年数据请分段提取</span>
                            </div>
                            <div style='width:50%'>
                                <el-date-picker
                                    v-model='selectRange'
                                    type='daterange'
                                    value-format='yyyy-MM-dd'
                                    range-separator='至'
                                    start-placeholder='开始日期'
                                    end-placeholder='结束日期'>
                                </el-date-picker>
                            </div>
                        </div>
                        <!-- 空气质量排名 -->
                        <div class='data_card' v-if='otherInfo.filterIndex == 17'>
                            <div class='top_tips'>选择数据频率</div>
                            <div class='flex-center'>
                                <el-radio-group v-model='airQualityInfo.frequency'>
                                    <el-radio label='当前排名'></el-radio>
                                    <el-radio label='某日数据'></el-radio>
                                    <el-radio label='某月数据'></el-radio>
                                    <el-radio label='某年数据'></el-radio>
                                </el-radio-group>
                            </div>
                            <div class='mat20'>
                                <el-date-picker
                                    v-if="airQualityInfo.frequency == '当前排名' || airQualityInfo.frequency == '某日数据'"
                                    v-model='selectDay' :disabled='airQualityInfo.frequency == 0' align='right'
                                    type='date' placeholder='选择日期' value-format='yyyy-MM-dd'
                                    :picker-options='pickerOptions'></el-date-picker>
                                <el-date-picker v-if="airQualityInfo.frequency == '某月数据'" v-model='selectMonth'
                                                align='right' type='month' placeholder='选择月份' value-format='yyyy-MM'
                                                :picker-options='pickerOptions'></el-date-picker>
                                <el-date-picker v-if="airQualityInfo.frequency == '某年数据'" v-model='selectYear'
                                                align='right' type='year' placeholder='选择年份' value-format='yyyy'
                                                :picker-options='pickerOptions'></el-date-picker>
                            </div>
                        </div>
                        <!-- 监测点空气质量 -->
                        <div class='data_card' v-if='otherInfo.filterIndex == 18'>
                            <div class='top_tips'>选择省份/城市</div>
                            <div class='flex-center'>
                                <div>
                                    <el-select v-model='airQualityInfo.province' @change='getProvinceOrCity'>
                                        <el-option :label='item' :key='index'
                                                   v-for='(item,index) in airQualityInfo.provinceArr'
                                                   :value='item'></el-option>
                                    </el-select>
                                </div>
                                <div>&nbsp;&nbsp;---&nbsp;&nbsp;</div>
                                <div>
                                    <el-select v-model='airQualityInfo.city'>
                                        <el-option :label='item' :key='index'
                                                   v-for='(item,index) in airQualityInfo.cityArr'
                                                   :value='item'></el-option>
                                    </el-select>
                                </div>
                            </div>
                            <div class='top_tips mat20'>选择日期范围<span class='ml10'>* 若提取小时频率数据请注意时间跨度不宜过长，提取日频率数据的早年数据请分段提取</span>
                            </div>
                            <div style='width:50%'>
                                <el-date-picker
                                    v-model='selectRange'
                                    type='daterange'
                                    value-format='yyyy-MM-dd'
                                    range-separator='至'
                                    start-placeholder='开始日期'
                                    end-placeholder='结束日期'>
                                </el-date-picker>
                            </div>
                        </div>
                    </div>
                    <!-- 生活成本 -->
                    <div v-if="otherInfo.name == '生活成本'">
                        <div class='other_info_text'>数据描述：<span>{{ otherInfo.info }}</span></div>
                        <div class='data_card'>
                            <div class='top_tips'>选择地理区域
                                <el-checkbox class='ml10' v-model='checkAll' @change='checkAllContract'>全选
                                </el-checkbox>
                            </div>
                            <div class='flex-center'>
                                <el-checkbox-group v-model='checkList'>
                                    <el-checkbox :key='index' v-for='(item,index) in multiChoiceList'
                                                 :label='item'></el-checkbox>
                                </el-checkbox-group>
                            </div>
                        </div>
                    </div>
                    <!-- 影视类 -->
                    <div v-if="otherInfo.name == '影视类'" class='filter_wrap'>
                        <!-- 过滤数据 -->
                        <div class='filter_button flex-center'>
                            <div @click='labelSwitching(item)' v-for='(item,index) in moviesInfo.filterArr' :key='index'
                                 :class="otherInfo.filterIndex == item.id ? 'active_button' : ''">{{ item.title }}
                            </div>
                        </div>
                        <div class='other_info_text'>数据描述：<span>{{ otherInfo.info }}</span></div>
                        <!-- 电影票房 -->
                        <div class='data_card' v-if='otherInfo.filterIndex == 20'>
                            <div class='top_tips'>选择时间维度</div>
                            <div class='select_wrap flex-between'>
                                <div>
                                    <el-radio v-model='moviesInfo.frequency' label='实时票房'></el-radio>
                                    <div class='select_text'>*
                                        当前时刻的实时电影票房数据，每5分钟更新一次数据，实时票房包含今天未开映场次已售出的票房
                                    </div>
                                </div>
                                <div>
                                    <el-radio v-model='moviesInfo.frequency' label='单日票房'></el-radio>
                                    <div class='select_text'>* 指定日期的电影票房数据，每日10:30，12:30更新日票房</div>
                                </div>
                                <div>
                                    <el-radio v-model='moviesInfo.frequency' label='单周票房'></el-radio>
                                    <div class='select_text'>*
                                        指定日期所在完整周的票房数据，影片周票房数据初始更新周期为每周二，下周二补充数据
                                    </div>
                                </div>
                            </div>
                            <div class='top_tips mat10'>选择数据日期</div>
                            <div>
                                <el-date-picker
                                    :disabled="moviesInfo.frequency == '实时票房'"
                                    v-model='selectDay'
                                    align='right'
                                    type='date'
                                    placeholder='选择日期'
                                    value-format='yyyy-MM-dd'
                                    :picker-options='pickerOptions'>
                                </el-date-picker>
                            </div>
                        </div>
                        <!-- 影视票房排行 -->
                        <div class='data_card' v-if='otherInfo.filterIndex == 21'>
                            <div class='top_tips'>选择时间维度</div>
                            <div class='select_wrap flex-center'>
                                <div>
                                    <el-radio v-model='moviesInfo.rankType' label='日票房排行'></el-radio>
                                    <div class='select_text'>*
                                        指定日期各影院的票房数据，注意当前日期的数据需要第二日才可以获取
                                    </div>
                                </div>
                                <div>
                                    <el-radio v-model='moviesInfo.rankType' label='周票房排行'></el-radio>
                                    <div class='select_text'>*
                                        指定日期的完整周各影院的票房数据，注意当前日期的数据只能返回上周的数据
                                    </div>
                                </div>
                            </div>
                            <div class='top_tips mat10'>选择数据日期</div>
                            <div>
                                <el-date-picker
                                    v-model='selectDay'
                                    align='right'
                                    type='date'
                                    placeholder='选择日期'
                                    value-format='yyyy-MM-dd'
                                    :picker-options='pickerOptions'>
                                </el-date-picker>

                            </div>
                        </div>
                        <!-- 视频放映 -->
                        <div class='data_card' v-if='otherInfo.filterIndex == 22'>
                            <div class='top_tips'>选择影视类数据</div>
                            <el-radio v-model='moviesInfo.videoType' label='电视剧集'></el-radio>
                            <el-radio v-model='moviesInfo.videoType' label='综艺节目'></el-radio>
                        </div>
                    </div>
                    <div class='but_btn' style='cursor: pointer'>
                        <div class='donload_btn' @click='queryTheData'>查询数据</div>
                        <div></div>
                    </div>
                </div>

                <!-- 数据预览-->
                <DataPreview
                    v-if='whetherToShowAPreview'
                    ref='dataPreview'
                    :down-load-data='downloadData'
                    api-url='/ms_resource/alternative/preview'
                    :queryParameters='queryParameters'
                ></DataPreview>
            </div>
        </StockData>
    </div>
</template>
<script>
import { otherMenu, otherSubMenu, provinceOrCity } from '../../utils/api';
import DataPreview from '@/components/common/DataPreview';

export default {
    components: {
        DataPreview
    },
    data() {
        return {
            menuList: [],
            activeIndex: 1,
            checkAll: false,
            checkList: [],
            multiChoiceList: [],
            pickerOptions: {
                disabledDate(data) {
                    return data && data.valueOf() >= new Date();
                    }
                },
                selectDay:'',
                selectMonth:'',
                selectYear:'',
                selectRange:['',''],
                otherInfo:{
                    name:'影视类',
                    info:'返回指定比赛年份的奥运会历届奖牌数据',
                    filterIndex:''
                },
                olympicInfo:{
                    filterArr:[]
                },
                carSaleInfo:{
                    filterArr:[]
                },
                sunInfo:{
                    filterArr:['以天为单位','以月为单位']
                },
                airQualityInfo:{
                    tableData:[{
                        index:'0-50',
                        grade:'一级',
                        status:'优',
                        proposal:'空气质量令人满意，基本无空气污染，各类人群可正常活动。'
                    },{
                        index:'51-100',
                        grade:'二级',
                        status:'良',
                        proposal:'空气质量可接受，但某些污染物可能对极少数异常敏感人群健康有较弱影响，建议极少数异常敏感人群应减少户外活动。'
                    },{
                        index:'101-150',
                        grade:'三级',
                        status:'轻度污染',
                        proposal:'易感人群症状有轻度加剧，健康人群出现刺激症状。建议儿童、老年人及心脏病、呼吸系统疾病患者应减少长时间、高强度的户外锻炼。'
                    },{
                        index:'151-200',
                        grade:'四级',
                        status:'中度污染',
                        proposal:'进一步加剧易感人群症状，可能对健康人群心脏、呼吸系统有影响，建议疾病患者避免长时间、高强度的户外锻练，一般人群适量减少户外运动。'
                    },{
                        index:'201-300',
                        grade:'五级',
                        status:'重度污染',
                        proposal:'心脏病和肺病患者症状显著加剧，运动耐受力降低，健康人群普遍出现症状，建议儿童、老年人和心脏病、肺病患者应停留在室内，停止户外运动，一般人群减少户外运动。'
                    },{
                        index:'>300',
                        grade:'六级',
                        status:'严重污染',
                        proposal:'健康人群运动耐受力降低，有明显强烈症状，提前出现某些疾病，建议儿童、老年人和病人应当留在室内，避免体力消耗，一般人群应避免户外活动。'
                    }],
                    filterArr:['全国空气质量','空气质量排名','检测点空气质量'],
                    frequency:0,
                    rankType:0,
                    province: '',
                    provinceArr: [],
                    city: '',
                    cityArr: []
                },
            moviesInfo: {
                filterArr: [],
                frequency: '实时票房',
                rankType: '日票房排行',
                videoType: '电视剧集'
            },
            queryParameters: {},
            whetherToShowAPreview: false
        }
        },
        created(){
            // this.menuList = JSON.parse('[{"title":"奥运奖牌"},{"title":"汽车销量排行"},{"title":"新闻联播文字稿"},{"title":"日出和日落"},{"title":"空气质量"},{"title":"生活成本"},{"title":"影视类"}]')
            this.getMenuList()
        },
        methods:{
            // 空气质量获取省份和城市
            getProvinceOrCity(name) {
                // 如果未传省份名，则是获取省份，如果传了省份名，就获取省份下的城市
                provinceOrCity({ province: name }).then(res => {
                    if (!!name) {
                        this.airQualityInfo.cityArr = res.data;
                    } else {
                        this.airQualityInfo.provinceArr = res.data;
                    }
                }).catch(err => {
                });
            },
            // 预览数据
            queryTheData() {
                this.whetherToShowAPreview = true;
                let params = {
                    codes: this.checkList.join(','),
                    id: this.otherInfo.filterIndex,
                    date: this.selectDay,
                    startDate: this.selectRange[0],
                    endDate: this.selectRange[1],
                    radio: '',//单选内容
                    symbol: this.airQualityInfo.city
                };
                switch (this.otherInfo.filterIndex) {
                    case 17:
                        params.radio = this.airQualityInfo.frequency;
                        break;
                    case 20:
                        params.radio = this.moviesInfo.frequency;
                        break;
                    case 21:
                        params.radio = this.moviesInfo.rankType;
                        break;
                    case 22:
                        params.radio = this.moviesInfo.videoType;
                        break;

                }
                this.queryParameters = params;
                setTimeout(() => {
                    this.$refs.dataPreview.queryTheData();
                });
            },
            //下载数据
            downloadData() {
                let params = {
                    codes: this.checkList.join(','),
                    id: this.otherInfo.filterIndex,
                    date: this.selectDay,
                    startDate: this.selectRange[0],
                    endDate: this.selectRange[1],
                    radio: '',//单选内容
                    symbol: this.airQualityInfo.city
                }
                switch(this.otherInfo.filterIndex){
                    case 17:
                        params.radio = this.airQualityInfo.frequency
                    break;
                    case 20:
                        params.radio = this.moviesInfo.frequency
                    break;
                    case 21:
                        params.radio = this.moviesInfo.rankType
                    break;
                    case 22:
                        params.radio = this.moviesInfo.videoType
                    break;

                }
                let url = this.$core.setObjToUrlParams(this.$config.BASE_URL + '/alternative/download', params);
                const loading = this.$loading({
                    lock: true,
                    text: '拼命加载中..',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                this.$core.downloadFileData('GET', url).then(res => {
                    loading.close();
                }).catch(err => {
                    loading.close();
                });

            },
            //标签切换
            labelSwitching(item) {
                this.otherInfo.filterIndex = item.id;
                this.otherInfo.info = item.description;
                this.checkAll = false;
                this.checkList = [];
                this.selectDay = '';
                this.selectMonth = '';
                this.selectYear = '';
                this.selectRange = ['', ''];
                this.whetherToShowAPreview = false;
            },
            // 清除缓存数据
            clearCache() {
                this.whetherToShowAPreview = false;
                this.checkAll = false;
                this.checkList = [];
                this.selectDay = '';
                this.selectMonth = '';
                this.selectYear = '';
                this.selectRange = ['', ''];
            },

            // 获取另类数据目录列表
            getMenuList(){
                otherMenu().then(res => {
                    this.menuList = res.data
                    this.otherInfo.name = res.data[0].title
                    otherSubMenu({id:res.data[0].id}).then(res => {
                        this.olympicInfo.filterArr = res.data
                        this.otherInfo.filterIndex = res.data[0].id
                        this.otherInfo.info = res.data[0].description
                    }).catch(err => {})
                }).catch(err => {})
            },

            // 更改筛选条件
            changeFilter(item){
                this.otherInfo.name = item.title
                this.otherInfo.info = item.description
            },

            // 选择所有合约
            checkAllContract(val){
                this.checkList = val ? this.multiChoiceList : [];
            },

            // el-submenu改变时获取index
            changeActive(index,item){
                this.otherInfo.name = item.title
                otherSubMenu({id:item.id}).then(res => {
                    this.clearCache()
                    this.olympicInfo.filterArr = res.data
                    this.otherInfo.filterIndex = res.data[0].id
                    this.otherInfo.info = res.data[0].description
                    if(this.otherInfo.name == '生活成本'){
                        this.multiChoiceList = JSON.parse(res.data[0].pageConditions[0].content);
                    }
                    if(this.otherInfo.name == '汽车销量'){
                        this.carSaleInfo.filterArr = res.data
                    }
                    if(this.otherInfo.name == '日出和日落'){
                        this.sunInfo.filterArr = res.data
                    }
                    if(this.otherInfo.name == '空气质量'){
                        this.airQualityInfo.filterArr = res.data
                        this.getProvinceOrCity('')
                    }
                    if(this.otherInfo.name == '影视类'){
                        this.moviesInfo.filterArr = res.data
                    }
                }).catch(err => {})
                this.activeIndex = item.id
            },

            // el-menu-item改变时操作
            changeItemActive(index){
                this.activeItemIndex = index
            }
        },
    }
</script>
<style lang='scss' scoped>
.select_wrap{
    width: 100%;
    >div{

        width: 28%;
    }
    .select_text{
        min-height: 130px;
        margin-top: 20px;
        font-size: 16px;
        line-height: 1.7;
        color: #B3B3B3;
    }
}
.other_info_text{
     font-size: 18px;
    font-weight: bold;
    color: #271B63;
    margin: 15px 0px;
    span{
        font-weight: 100;
    }
}
.top_tips{
    padding-left: 20px;
    font-size: 20px;
    position: relative;
    left: -30px;
    span{
        color: #999;
        font-size: 14px;
    }
}
.exchange_name{
    font-weight: bold;
    font-size: 24px;
    color: #271B63;
    i{
        font-size: 20px;
    }
}
/deep/td{
        border-bottom: 1px solid #e6e6e6;
        padding: 8px 0px !important;
    }
.data_card{
    box-sizing: border-box;
    padding: 40px 120px;
    background: white;
    font-size: 18px;
    margin-top: 10px;
    border-radius: 10px 10px 0px 0px;

    /deep/.el-checkbox{
        min-width: 150px;
        margin-bottom: 15px;
    }
    /deep/.el-radio__label{
        font-size: 18px;
    }
}
.download-button{
    margin: 20px auto 0px 90px ;
}
.other_data_content{
    width: 90%;
}
.filter_wrap{
    .filter_button{
        margin-top: 30px;
        >div{
            padding: 10px 40px;
            color: #666666;
            background: white;
            margin-right: 15px;
            border-radius: 4px;
            font-size: 18px;
            &:hover{
                @extend .active_button;
                cursor: pointer;
                opacity: 0.8;
            }
        }
        .active_button{
            color: white;
            background: #002D72;
        }
    }

}
</style>
